import styled, { keyframes } from 'styled-components'
const menuhidden = keyframes`
  0% { 
    opacity: 1;
    display: inline;
   }

   25% {
    opacity: 0.75;
   }
   50% {
    opacity: 0.5;
   }
   75% {
    opacity: 0.25;
   }

  100% { 
    opacity: 0;
    display: none;
    visibility: hidden
   }
`
export const MenuContainer = styled.aside`
    grid-area: menu;
    display: flex;
    flex-direction: column;
    /* background-color: #1a2e44; */
    /* background-color: #000e2b; */
    /* background-color: #1f1f23; */
    /* background-color: #18181b; */
    /* background-color: #1f1f23; */
    /* background: #333; */
    background: #fff;
    /* background-color: #000e2b; */

    position: relative;
    border-right: 1px solid #d3d3d3;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    height: 100%;
    transition: background 0.2s ease-in-out;

    .close-menu {
        position: absolute;
        bottom: 10px;
        right: 10px;
        color: #333;
        font-size: 30px;

        &.dark {
            color: #fff;
        }
        @media (min-width: 501px) {
            display: none;
        }
    }

    &.open {
        @media (max-width: 500px) {
            z-index: 99;
            width: 100vw;
        }
    }

    &.dark {
        background: #282525;
    }
`

export const Logo = styled.div`
    display: flex;
    justify-content: center;
    /* align-items: center; */
    padding-right: 10px;
    /* margin-top: 10px; */
    /* margin-bottom: 10px; */
    min-height: 80px;
    position: relative;

    a {
        /* display: flex; */
        /* flex-direction: column; */
        /* align-items: center; */
        /* gap: 8px; */
    }

    img {
        width: 200px;
        height: 100px;
        flex-shrink: 0;
        @media (max-width: 500px) {
            /* width: 200px; */
            /* height: 40px; */
        }
    }

    button {
        position: absolute;
        top: 50px;
        right: -12px;
        color: #333;
        background: #fff;
        padding: 1px;
        border-radius: 50%;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        transform: rotate(0);
        transition: transform 0.15s ease-in;
        z-index: 7;

        &.open {
            transform: rotate(180deg);
        }
    }
`

export const Nav = styled.nav`
    height: 100%;
    ul {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    /* li {
        width: max-content;
    } */

    .top {
        margin-top: 10px;
    }

    .bottom {
        margin-bottom: 20px;
    }
    li {
        .item {
            &:hover {
                /* background-color: #38445e; */
            }
        }

        .item {
            display: flex;
            align-items: center;
            color: #a3abb4;
            color: #e0e0e0;
            color: #333;
            color: #a3abb4;
            color: #777878;
            font-size: 23px;
            padding: 11px 10px 11px 15px;
            font-family: 'Inter', sans-serif;
            font-weight: 500;
            /* overflow: hidden; */
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 4px;

            span {
                margin-left: 5px;
                font-size: 16px;

                &.close {
                    /* animation: ${menuhidden} 0.5s ease-in-out; */
                    /* display: none; */
                }
                /* display: none; */
            }

            svg {
                flex-shrink: 0;
            }

            &.active {
                position: relative;
                color: #fff;
                color: #333;
                font-weight: 500;
                /* background-color: #38445e; */
                /* border-left: 3px solid #009ddd; */
                border-radius: 0 12px 12px 0;
                /* background: rgba(37, 99, 235, 0.2); */
                background: rgba(22, 163, 74, 0.2);
                svg {
                    /* color: rgb(37, 99, 235); */
                    color: rgb(22 163 74);
                }

                span {
                    /* color: rgb(37, 99, 235); */
                    color: rgb(22 163 74);
                }

                &::before {
                    content: '';
                    position: absolute;
                    width: 4px;
                    height: 100%;
                    /* background-color: rgb(37, 99, 235); */
                    background-color: rgb(22 163 74);
                    border-radius: 0 6px 6px 0;
                    left: 0;
                    z-index: 7;
                }
            }

            .arrow-icon {
                margin-left: auto;
                font-size: 14px;
                transform: rotate(0deg);
                transition: transform 0.15s ease-in;

                &.open {
                    transform: rotate(90deg);
                }
            }
        }

        &.toogle {
            display: flex;
            align-items: center;
            /* justify-content: space-between; */
            gap: 18px;
            padding: 11px 10px 11px 15px;
            font-family: 'Inter', sans-serif;
            font-weight: 500;
            text-overflow: ellipsis;
            white-space: nowrap;

            label {
                color: #777878;
                /* color: #333;
                &.dark {
                    color: #fff;
                } */
            }
        }
    }

    .sub-list .item {
        padding-left: 40px;
        font-size: 20px;
    }
`
